import React from 'react';

const ChatContext = React.createContext({
  targetId: '',
  setTargetId: () => {},
  type: '',
  setType: () => {},
  joinGroupChat: () => {},
  leaveChatRoom: () => {},
  setChatRoomTitle: () => {},
});

export default ChatContext;
